import { Tooltip } from '../Tooltip';
import { Icon } from '../Icon';

import type { FC } from 'react';

type QuestionMarkTooltipProps = {
  className?: string;
  text: string;
};

export const QuestionMarkTooltip: FC<QuestionMarkTooltipProps> = ({ className, text }) => (
  <Tooltip placement="top-end" variant="outline" text={text}>
    <Icon className={className} type="QuestionMarkIcon" />
  </Tooltip>
);
